<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <template v-if="CheckAdmin">
        <v-card>
          <v-card-title class="font-weight-bold">
            <span>ตั้งค่างบวิชาการคงเหลือ</span>
          </v-card-title>
          <v-list style="width: 100%">
            <v-list-item>
              <v-stepper non-linear style="width: 100%">
                <v-stepper-header>
                  <v-stepper-step
                      editable
                      step="1"
                      class="font-weight-bold"
                  >
                    งบวิชาการตั้งต้น (บุคคล)
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step
                      editable
                      step="2"
                      class="font-weight-bold"
                  >
                    งบวิชาการตั้งต้น (ตำแหน่ง)
                  </v-stepper-step>

                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content
                      step="1"
                  >
                    <v-list>
                      <v-list-item>
                        <v-row class="d-flex justify-center">
                          <v-col
                              cols="12"
                              md="6">
                            <v-autocomplete
                                v-model="DepSelect"
                                label="หน่วยงาน"
                                :items="depart"
                                item-text="dep_name"
                                item-value="dep_id"
                                hint="หน่วยงาน (ห้ามว่าง)"
                                persistent-hint
                                clearable
                                @change="chooseDepartID"
                                @click:clear="clearDepartID"
                            >
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="ค้นหา"
                        ></v-text-field>
                      </v-list-item>
                      <v-list-item>
                        <v-data-table
                            :search="search"
                            style="width: 100%"
                            :headers="headerTbl"
                            :items="AcademicFundsRemain"
                            class="font-weight-bold"
                        >
                          <template v-slot:header.perid>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              รหัส
                            </v-label>
                          </template>
                          <template v-slot:header.full_Name>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              ชื่อ - สกุล
                            </v-label>
                          </template>
                          <template v-slot:header.academic_funds>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              งบวิชาการคงเหลือ
                            </v-label>
                          </template>
                          <template v-slot:item.academic_funds="{item}">
                            <span>{{ item.academic_funds | currency }}</span>
                          </template>
                          <template v-slot:item.action="{item}">
                            <v-btn text color="primary" @click="editAcademicFunds(item)"
                                   class="text--darken-4 font-weight-bold">
                              แก้ไขงบวิชาการ
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-list-item>
                    </v-list>
                  </v-stepper-content>
                  <v-stepper-content
                      step="2"
                  >
                    <v-card
                        class="mb-12"
                        color="grey lighten-1"
                        height="200px"
                    >

                    </v-card>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-list-item>
          </v-list>
        </v-card>
      </template>
      <template v-else>
        <v-card>
          <v-card-text>
            <v-responsive class="justify-center align-center text-center" height="500px">
                      <span style="font-size: 50px;font-weight: bold">
                        คุณไม่ได้รับสิทธิ์การใช้งานเมนู
                      </span>
            </v-responsive>
          </v-card-text>
        </v-card>
      </template>
      <v-dialog
          v-model="showDialogEditAcademicFunds"
          max-width="500"
      >
        <v-card v-if="objAcademicFunds != null">
          <v-card-title class="font-weight-bold">
            <span>แก้ไขข้อมูลงบวิชาการคงเหลือ คุณ : {{ objAcademicFunds.full_Name }} ({{ objAcademicFunds.perid }})</span>
          </v-card-title>
          <v-card-text>
            <div align="center" class="mt-6">
              <v-text-field outlined v-model="txtAcademicFunds" label="งบวิชาการ"></v-text-field>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="clearDialogEditAcademicFunds">ยกเลิก</v-btn>
            <v-btn color="green darken-1" text @click="editDataAcademicFunds">บันทึก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import axios from 'axios'
import ConstData from '../const/Const'
import {mapActions, mapGetters} from "vuex";
import Const from "@/const/Const";
// import ALlFunc from "@/FuncGlobal/ALlFunc";

export default {
  name: "AcademicFundsRemaining",
  data() {
    return {
      txtAcademicFunds: '',
      showDialogEditAcademicFunds: false,
      objAcademicFunds: null,
      DepSelect: null,
      search: '',
      AcademicFundsRemain: [],
      headerTbl: [
        {text: 'รหัส', value: 'perid'},
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'งบวิชาการ', value: 'academic_funds'},
        {text: '', value: 'action'},
      ],
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      CheckAdmin: false,
    }
  },
  computed: {
    functionEvents() {
      return this.month ? this.monthFunctionEvents : this.dateFunctionEvents
    },
    ...mapGetters({
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      Comittee_Data: 'Project/getComittee',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      textForPrint: 'Project/getTextForPrint',
      countryData: 'Project/getCountry',
      projectPalnData: 'Project/getProjectPlan',
      GroupExamData: 'Project/getGroupExamProject',
      QuotaDepartData: 'Project/getQuotaDepart',
      JoinProjectData: 'Project/getJoinProject',
      GroupQuotaData: 'Project/getGroupQuota',
      GroupQuotaMS: 'Project/getGroupQuota_Ms',
      ProjectRound: 'Project/getProjectRound',
      ApproveForm: 'Project/getApproveForm',
      ProjectRecord: 'Project/getProjectRecord',
      TravelForm: 'Project/getTravelForm',
      JoinTravelRes: 'Project/getJoinTravel',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      MeData: 'Staff/getMeData',
      AdminData: 'Staff/getAdminData',
      ApproveMaster: 'Staff/getApproveMaster',
      AcademicFunds: 'Staff/getAcademicFunds',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      ProjectCompetency: 'Project/getCompetency',
      ProjectExpense: 'Project/getProjectExpense',
      AllPermission: 'Permission/getAllPermission',
      Permission: 'Permission/getPermissionUser',

      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      PermissionAdmin: 'Permission/getPermission',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      TypeProject: 'Project/getTypeProject',
      StatusProject: 'Project/getStatusProject',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      MangeTextForPrint: 'Project/MangeTextForPrint',
      initCountryData: 'Project/initCountryData',
      initProjectExpenseData: 'Project/initProjectExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initGroup_Quota: 'Project/initGroup_Quota',
      initGroup_Quota_Ms: 'Project/initGroup_Quota_Ms',
      getProjectRoundData: 'Project/getProjectRoundData',
      getGroupExamProjectByCordi: 'Project/getGroupExamProjectByCordi',
      getQuotaDepartRegisterByCordi: 'Project/getQuotaDepartRegisterByCordi',
      getJoinProjectByCordi: 'Project/getJoinProjectByCordi',
      initApproveFormData: 'Project/initApproveFormData',
      initProjectRecordData: 'Project/initProjectRecordData',
      changeTypeProject: 'Project/changeTypeProject',
      initFileReportTravel: 'Project/initFileReportTravel',
      initJoinTravel: 'Project/initJoinTravel',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initMeData: 'Staff/initMeData',
      initAdminData: 'Staff/initAdminData',
      initApproveMaster: 'Staff/initApproveMaster',
      getAcademicFundsRemain: 'Staff/getAcademicFundsRemain',
      initApproveMasterByType: 'Staff/initApproveMasterByType',
      initPermissionData: 'Permission/initPermissionData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionData: 'Permission/getPermissionData',

      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
    }),
    init() {
      this.initDepartData().then(res => {
        if (res) {
          this.DepSelect = this.MeData[0].dep_id
          this.chooseDepartID()
        }
      })
    },
    chooseDepartID() {
      this.AcademicFundsRemain = []
      if (this.DepSelect != null) {
        this.getAcademicFundsRemain({
          depart_id: this.DepSelect
        }).then(res => {
          if (res) {
            if (this.AcademicFunds.length > 0) {
              this.AcademicFundsRemain = this.AcademicFunds
            }
          }
        })
      }
    },
    clearDepartID() {

    },
    editDataAcademicFunds() {
      this.CheckPermissionFunc('17001').then(resPermiss => {
        if (resPermiss) {
          this.$swal.fire({
            title: 'ยืนยันการทำรายการ',
            text: "ต้องการแก้ไขข้อมูลงบวิชาการคงเหลือ คุณ : " + this.objAcademicFunds.full_Name + ' ใช่หรือไม่ ??',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.value) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Academic_Funds_Remain/perid/' + this.objAcademicFunds.perid, {
                active: '0',
                update_by: this.MeData[0].perid,
              }, {
                headers: {
                  'Content-Type': 'application/json',
                }
              }).then(res => {
                console.log(res.data.status)
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Academic_Funds_Remain', {
                  perid: this.objAcademicFunds.perid,
                  academic_funds: this.txtAcademicFunds,
                  create_by: this.objAcademicFunds.perid,
                  create_time: 'now()',
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }).then(res => {
                  if (res.data.status) {
                    this.showDialogEditAcademicFunds = false
                    this.chooseDepartID()
                    this.$swal.fire({
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง!!'
                    })
                  }
                }).catch(res => {
                  if (res) {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง!!'
                    })
                  }
                })
              }).catch(res => {
                if (res) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง หรือ ตรวจสอบการเชื่อมต่ออินเตอร์เน็ต!!'
                  })
                }
              })
            }
          })
        } else {
          this.dialogLoading = false
          this.btnDisable = false
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    editAcademicFunds(objAcademicFunds) {
      this.txtAcademicFunds = ''
      this.objAcademicFunds = null
      this.objAcademicFunds = objAcademicFunds
      this.txtAcademicFunds = objAcademicFunds.academic_funds
      this.showDialogEditAcademicFunds = true
    },
    clearDialogEditAcademicFunds() {
      this.txtAcademicFunds = ''
      this.objAcademicFunds = null
      this.showDialogEditAcademicFunds = false
    },
    CheckPermissionFunc(permissionId) {
      return new Promise(resolve => {
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == permissionId) {
              resolve(true)
            } else {
              if (idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == permissionId) {
              resolve(true)
            } else {
              if (idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
  },
  mounted() {
    this.changeColor({
      color: Const.defaultColorApp
    })
    this.changeHeaderName({
      headerName: Const.defaultHeaderApp
    })
    this.dialogLoading = true
    if (this.TypeProject == null) {
      this.changeTypeProject({
        type: '1'
      })
    }
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '24'
        })
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(res => {
          if (res) {
            this.PermissionAdmin.map(Per_i => {
              if (Per_i.permission_id == '17000') {
                this.getMenuPermissData().then(res => {
                  if (res) {
                    if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '24' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                      this.maintain = false
                      this.init()
                    } else {
                      this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '24' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '24')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                      this.maintain = true
                    }
                  }
                }).then(err => {
                  if (err) {
                    this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '24' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '24')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                    this.maintain = true
                  }
                })
              }
            })
            this.CheckAdmin = true
            this.dialogLoading = false
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(res => {
              if (res) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '17000') {
                    this.getMenuPermissData().then(res => {
                      if (res) {
                        if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '24' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                          this.maintain = false
                          this.init()
                        } else {
                          this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '24' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '24')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                          this.maintain = true
                        }
                      }
                    }).then(err => {
                      if (err) {
                        this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '24' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '24')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                        this.maintain = true
                      }
                    })
                    this.CheckSubAdmin = true
                    this.dialogLoading = false
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>


